// defaultColors.ts
export const defaultChartColors = [
  '#295681',
  '#2975AB',
  '#2a94d6',
  '#69b096',
  '#b3d14B',
  '#FDF200',
  '#f9ca21',
  '#f59b48',
  '#f16c6f',
  '#b55e69',
  '#6e4d63',
  '#283c5c',
];
